import Cookies from 'js-cookie';
import { ExperimentData } from '~helpers/types';

export const CONTENTEXP_755 = {
  identifier: 'contentexp-14-auth0-sign-ups',
  control: 'contentexp-14-auth0-sign-ups-control',
  treatment: 'contentexp-14-auth0-sign-ups-treatment',
};

export const ENDPAGE_132 = {
  identifier: 'endpage-132-banner-experiment',
  control: 'endpage-132-banner-experiment-control',
  treatment1: 'endpage-132-banner-experiment-treatment-1',
  treatment2: 'endpage-132-banner-experiment-treatment-2',
};

export const ENDPAGE_122 = {
  identifier: 'endpage-122-dare-to-ask',
  control: 'endpage-122-rebrandEpForm',
  treatment1: 'endpage-122-dareToAskCTA1',
  treatment2: 'endpage-122-dareToAskCTA2',
  treatment3: 'endpage-122-dareToAskSignUp',
  treatment4: 'endpage-122-rebrandEpFormImage1',
  treatment5: 'endpage-122-rebrandEpFormImage2',
};

export const ENDPAGE_35 = {
  identifier: 'endpage-35-optional-pathing',
  control: 'endpage-35-rebrandEpForm',
  treatment1: 'endpage-35-optionalPath1',
  treatment2: 'endpage-35-optionalPath2',
  treatment3: 'endpage-35-optionalPath3',
};

export const ENDPAGE_151 = {
  identifier: 'endpage-151-dare-to-ask-v2',
  control: 'endpage-151-rebrandEpForm',
  treatment1: 'endpage-151-dareToAskPractical',
  treatment2: 'endpage-151-dareToAskZesty',
};

export const ENDPAGE_147 = {
  identifier: 'endpage-147-optional-pathing',
  control: 'endpage-147-rebrandEpForm',
  treatment1: 'endpage-147-optionalPathsMWeb1',
  treatment2: 'endpage-147-optionalPathsMWeb2',
  treatment3: 'endpage-147-optionalPathsMApp1',
  treatment4: 'endpage-147-optionalPathsMApp2',
};

export const ENDPAGE_156 = {
  identifier: 'endpage-156-dare-to-ask-v2-uk',
  control: 'endpage-156-rebrandEpForm',
  treatment1: 'endpage-156-dareToAskPracticalUk',
  treatment2: 'endpage-156-dareToAskZestyUk',
};

export const ENDPAGE_171 = {
  identifier: 'endpage-171-dare-to-ask-v3',
  control: 'endpage-171-rebrandEpForm',
  treatment1: 'endpage-171-dareToAskV3SignUp',
  treatment2: 'endpage-171-dareToAskCreate',
  treatment3: 'endpage-171-dareToAskPractical',
};

export const ENDPAGE_162 = {
  identifier: 'endpage-162-product-userResearch',
  control: 'endpage-162-rebrandEpForm',
  treatment1: 'endpage-162-userResearchStandard',
  treatment2: 'endpage-162-userResearchStyled',
  treatment3: 'endpage-162-userResearchMobileStyle',
};

export const GROW_4165 = {
  identifier: 'grow-4165-endpageBuildWithAI',
  control: 'grow-4165-rebrandEpForm',
  treatment1: 'grow-4165-endpageBuildWithAIT1',
  treatment2: 'grow-4165-endpageBuildWithAIT2',
};

export const ENDPAGE_180 = {
  identifier: 'endpage-180-bwaiGIFTest',
  control: 'endpage-180-rebrandEpForm',
  treatment1: 'endpage-180-bwaiGIFInsight',
  treatment2: 'endpage-180-bwaiGIFCreation',
};

export function setExperimentCookies(experiments?: ExperimentData[]): void {
  const experimentCookies = new Map<string, { name: string; value: string; age: number }>();
  experiments?.forEach(experiment => {
    experiment?.cookies?.forEach(({ name, value, age }) => {
      // if the cookie hasn't been added to the map or has a longer value than what exists, update it
      if (!experimentCookies.has(name)) {
        experimentCookies.set(name, { name, value, age });
      }
      // Ensure we have a defined variable to compare with potential replacement cookie value
      const currentCookies = experimentCookies.get(name) ?? { value: '' };
      if (currentCookies.value.length < value.length) {
        experimentCookies.set(name, { name, value, age });
      }
    });
  });
  // set all the finalized cookies
  experimentCookies.forEach(({ name, value, age }) => {
    Cookies.set(name, value, { expires: age });
  });
}
